import { CounterOffersProps } from "./counter-offers.types";
import { CounterOffersView } from "./counter-offers-view";
import { useCounterOffers } from "./use-counter-offers";

export const CounterOffers: React.FC<CounterOffersProps> = (props) => {
  const logic = useCounterOffers(props);
  return <CounterOffersView {...logic} />;
};
